import { homApi } from '~/redux/apis/hom'
import { CURRICULUM_TYPE } from '~/redux/constants/tags.const'

import { normalizeCountryCode } from '../utils/helpers'
import { CurriculumMappingQuizQuestionResponseDto, CurriculumMappingQuizTaskDto } from '../types/mapping-quiz.types'

export const mappingQuizApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    setMappingQuizAnswer: builder.mutation<
      CurriculumMappingQuizQuestionResponseDto,
      {
        countryCode: string
        gradeLevel: string
        curriculumSubject: string
        preAskedQuesIds: string[]
        questionId: string
        quizId: string
        subjectOrder: number
        answer: number
        version: string
      }
    >({
      query: (data) => ({
        url: '/v1/curriculum/quiz',
        method: 'POST',
        body: normalizeCountryCode(data),
      }),
    }),
    getMappingQuiz: builder.query<
      CurriculumMappingQuizQuestionResponseDto,
      {
        countryCode: string
        gradeLevel: string
        subjectOrder: number
        curriculumSubject: string
        version: string
        reset?: boolean
      }
    >({
      query: (params) => ({
        url: '/v1/curriculum/quiz',
        method: 'GET',
        params: normalizeCountryCode(params),
      }),
    }),
    getMappingQuizPrerequisiteTasks: builder.query<
      CurriculumMappingQuizTaskDto,
      { countryCode: string; gradeLevel: string; subjectOrder: number; version?: string; subTopicSlug?: string }
    >({
      query: (params) => ({
        url: '/v1/curriculum/quiz-task',
        method: 'GET',
        params: normalizeCountryCode(params),
      }),
      providesTags: [CURRICULUM_TYPE.CURRICULUM_MAPPING_QUIZ_TASKS],
    }),
    getUserHasCompletedAnyMappingQuiz: builder.query<{ hasCompletedAnyQuiz: boolean }, void>({
      query: () => ({
        url: '/v1/curriculum/quiz/has-completed-any',
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetMappingQuizQuery,
  useGetMappingQuizPrerequisiteTasksQuery,
  useSetMappingQuizAnswerMutation,
  useGetUserHasCompletedAnyMappingQuizQuery,
} = mappingQuizApi
